import { ProfileButton } from '@flexo/atoms';
import { IconWrapper } from '@flexo/general';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import styles from './header-web.module.scss';

const ENV = (import.meta as any).env;

const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);

function HeaderWebApiKeys(props: Record<string, unknown>) {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const label = (props.label as string) || 'apiKeys';

  return (
    <div
      className={`${styles.Header__Web} ${
        isSafari ? styles.Header__Web__Safari : ''
      }`}
    >
      <div className={styles.Header__Web__Left}>
        <div
          className={styles.Logo}
          onClick={() => navigate(ENV.VITE_APP_FIRST_PAGE)}
        >
          <IconWrapper iconName="logo" />
        </div>
        <div className={styles.Header__Navigation}>
          <strong>{t(`widgets.header.${label}`)}</strong>
        </div>
      </div>

      <div className={styles.Header__Web__Right}>
        {props.profile && <ProfileButton />}
      </div>
    </div>
  );
}

export default React.memo(HeaderWebApiKeys);
